import {FormControl, MenuItem, Select, OutlinedInput} from '@material-ui/core'
import useToolbarStyles, {
  useOutlinedInputStyles,
} from 'components/Table/useTableToolbarStyles'

import React, {useState} from 'react'
import {useTranslation} from 'react-i18next'
import {
  LIST_COUNTRY,
  LIST_INSTITUTIONS,
  LIST_PRODUCT_TYPE,
  SEARCH_KEY,
} from 'pages/ProductOperationOrganization/constant'
import SearchBar from 'components/Forms/SearchBar'

interface ChangeSelectParams {
  key: string
  value: string
}

interface TableToolbarProps {
  onChangeSelect: (params: ChangeSelectParams) => void
  onSearch: (key: string, value: string) => void
}

const TableToolbar = ({onChangeSelect, onSearch}: TableToolbarProps) => {
  const classes = useToolbarStyles()
  const outlinedInputClasses = useOutlinedInputStyles()
  const {t} = useTranslation()
  const [institutions, setInstitutions] = useState<string>(
    LIST_INSTITUTIONS[0].value,
  )

  const [country, setCountry] = useState<string>(LIST_COUNTRY[0].value)

  const [productType, setProductType] = useState<string>(
    LIST_PRODUCT_TYPE[0].value,
  )

  const [searchField, setSearchField] = useState<string>(SEARCH_KEY[0].value)

  const [key, setKey] = useState<string>(SEARCH_KEY[0].value)

  const [searchKeyword, setSearchKeyword] = useState('')

  return (
    <div className={classes.container}>
      <FormControl variant='outlined'>
        <Select
          value={institutions}
          onChange={(e) => {
            onChangeSelect({
              key: 'orgType',
              value: String(e.target.value),
            })
            setInstitutions(String(e.target.value))
          }}
          className={classes.searchSelect}
          style={{width: '200px'}}
          input={
            <OutlinedInput
              name='age'
              id='outlined-age-simple'
              classes={outlinedInputClasses}
            />
          }
        >
          {LIST_INSTITUTIONS.map((item) => (
            <MenuItem value={item.value} key={item.value}>
              {t(item.label)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant='outlined'>
        <Select
          value={country}
          onChange={(e) => {
            onChangeSelect({
              key: 'domestic',
              value: String(e.target.value),
            })
            setCountry(String(e.target.value))
          }}
          className={classes.searchSelect}
          input={
            <OutlinedInput
              name='age'
              id='outlined-age-simple'
              classes={outlinedInputClasses}
            />
          }
        >
          {LIST_COUNTRY.map((item) => (
            <MenuItem value={item.value} key={item.value}>
              {t(item.label)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant='outlined'>
        <Select
          value={productType}
          onChange={(e) => {
            onChangeSelect({
              key: 'paymentType',
              value: String(e.target.value),
            })
            setProductType(String(e.target.value))
          }}
          style={{width: '220px'}}
          className={classes.searchSelect}
          input={
            <OutlinedInput
              name='age'
              id='outlined-age-simple'
              classes={outlinedInputClasses}
            />
          }
        >
          {LIST_PRODUCT_TYPE.map((item) => (
            <MenuItem value={item.value} key={item.value}>
              {t(item.label)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant='outlined'>
        <Select
          value={key}
          onChange={(e) => {
            setSearchField(String(e.target.value))
            setKey(String(e.target.value))
          }}
          style={{width: '180px'}}
          className={classes.searchSelect}
          input={
            <OutlinedInput
              name='age'
              id='outlined-age-simple'
              classes={outlinedInputClasses}
            />
          }
        >
          {SEARCH_KEY.map((item) => (
            <MenuItem value={item.value} key={item.value}>
              {t(item.label)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <SearchBar
        onChangeValue={setSearchKeyword}
        onSearchEvent={() => onSearch(searchField, searchKeyword)}
        value={searchKeyword}
        disabledValue={false}
      />
    </div>
  )
}

export default TableToolbar
